import { AccountListModel, DefaultAccountListModel } from '../AccountList';
import { SelectOptions } from 'components/commonType';
import { AccountManager, Account } from 'core';
import {
  UpdateEventListener,
  FireableUpdateEventListener,
} from 'utils/UpdateEventListener';
import { Pagination } from 'core/pagination/Pagination';
export type AccountsHomeState = {
  readonly loading: boolean;
  readonly error: Error | null;
  readonly accounts: Array<Account>;
  readonly selectAgency?: number;
  readonly searchString: string;
  readonly pagination?: Pagination;
};

export interface AccountsHomeModel {
  refresh(page: number, size: number): Promise<void>;
  getAccountListModel(): AccountListModel;
  onAgencyChange(agencyId): void;
  handleOnSearch(searchString: string): void;

  readonly agencyOptions?: SelectOptions[];
  readonly state: AccountsHomeState;
  readonly event: UpdateEventListener<AccountsHomeModel>;
  readonly rootPath: string;
  readonly filteredAccounts?: Array<Account>;
  readonly total?: number;
}

export type AccountsHomeProps = {
  readonly model: AccountsHomeModel;
};

export class DefaultAccountsHomeModel implements AccountsHomeModel {
  loading: boolean;
  error: Error | null;
  event: FireableUpdateEventListener<AccountsHomeModel>;

  manager: AccountManager;
  accounts: Array<Account> = [];
  rootPath: string = '/accounts';
  searchString: string = '';
  filteredAccounts: Array<Account> = [];
  pagination?: Pagination;

  constructor(
    manager: AccountManager,
    protected isSysAdmin: boolean,
  ) {
    this.manager = manager;
    this.error = null;
    this.loading = false;
    this.event = new FireableUpdateEventListener<AccountsHomeModel>();
  }

  get state(): AccountsHomeState {
    return {
      error: this.error,
      loading: this.loading,
      accounts: this.accounts,
      searchString: this.searchString,
      pagination: this.pagination,
    };
  }

  getAccountListModel(): AccountListModel {
    return new DefaultAccountListModel(this.filteredAccounts, this.isSysAdmin);
  }

  async refresh(page: number, size: number): Promise<void> {
    this.notify(true);
    try {
      const response = await this.manager.getAccounts(
        page,
        size,
        this.searchString,
      );
      this.accounts = response.accounts;
      this.pagination = response.pagination;
      this.updateViewData();
      this.notify(false);
    } catch (error) {
      this.notify(false, error as Error);
    }
  }

  updateViewData() {
    this.filteredAccounts = this.accounts.filter(
      (account) =>
        this.searchString === '' ||
        account.name.toLowerCase().includes(this.searchString.toLowerCase()) ||
        account.email.toLowerCase().includes(this.searchString.toLowerCase()),
    );
  }

  onAgencyChange(_) {}

  handleOnSearch = (searchString: string) => {
    this.searchString = searchString;
    this.refresh(1, 10);
  };

  notify(loading: boolean, error: Error | null = null) {
    this.error = error;
    this.loading = loading;
    this.event.fireEvent(this);
  }
}
